var _defs, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyCondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "w3",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC98A"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 204,
    rx: 140,
    ry: 12,
    fill: "rgba(20,10,80,.3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 188,
    width: 272,
    height: 12,
    rx: 6,
    fill: "#7CD6A8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 84,
    height: 170,
    rx: 4,
    fill: "url(#w3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 62,
    width: 60,
    height: 128,
    rx: 4,
    fill: "#D9D3FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 32,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 32,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 32,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 53,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 53,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 53,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 74,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 74,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 74,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 95,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 95,
    width: 16,
    height: 12,
    rx: 2,
    fill: "#FFD36B",
    stroke: "#fff",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 95,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 116,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 116,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 116,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 137,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 137,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 137,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 158,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 158,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 158,
    width: 16,
    height: 12,
    rx: 2,
    fill: "url(#g3)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 74,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 74,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 95,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 95,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 116,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 116,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 137,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 137,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 158,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 158,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#B9AEF5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 170,
    width: 24,
    height: 20,
    rx: 2,
    fill: "#6C5CE7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 170,
    r: 20,
    fill: "#4FBF8B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 172,
    r: 16,
    fill: "#4FBF8B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyCondo);
export default __webpack_public_path__ + "static/media/property-condo.cc04fbf222eb8166ba16c8a878a87501.svg";
export { ForwardRef as ReactComponent };